import { uiText } from './text.js';

/**
 * The bag's « Détruire » button, beside « Ranger » (ADR 0084). A click arms
 * it: the next item clicked in the bag is the one to destroy. A bag item
 * dragged onto it does the same in one gesture. Either way the confirmation
 * window comes first, and the server decides.
 */
export class BagDestroyButton {
  readonly element: HTMLButtonElement;

  constructor(handlers: { onArm: () => void; onDrop: (itemId: string) => void }) {
    this.element = document.createElement('button');
    this.element.type = 'button';
    this.element.className = 'bag-sort bag-destroy';
    this.element.textContent = uiText('Détruire');
    this.element.title = uiText('Détruire un objet du sac : clique-le ensuite, ou glisse-le ici');
    this.element.addEventListener('click', () => {
      if (!this.element.disabled) handlers.onArm();
    });
    this.element.addEventListener('dragover', (event) => {
      if (this.element.disabled) return;
      event.preventDefault();
      this.element.classList.add('bag-destroy--over');
    });
    this.element.addEventListener('dragleave', () => {
      this.element.classList.remove('bag-destroy--over');
    });
    this.element.addEventListener('drop', (event) => {
      event.preventDefault();
      this.element.classList.remove('bag-destroy--over');
      const raw = event.dataTransfer?.getData('application/x-shefira-item');
      if (raw === undefined || raw === '' || this.element.disabled) return;
      const source: unknown = JSON.parse(raw);
      // Only the bag: worn pieces and the wardrobe are out of reach (ADR 0084).
      if (
        typeof source === 'object' &&
        source !== null &&
        'from' in source &&
        source.from === 'bag' &&
        'itemId' in source &&
        typeof source.itemId === 'string'
      ) {
        handlers.onDrop(source.itemId);
      }
    });
  }

  /** Greyed while another window takes from the bag, and with nothing in it; lit while armed. */
  update(state: { picking: boolean; empty: boolean; armed: boolean }): void {
    this.element.disabled = state.picking || state.empty;
    this.element.classList.toggle('bag-destroy--armed', state.armed);
    this.element.setAttribute('aria-pressed', String(state.armed));
  }
}
